<template>
    <div>

        <v-toolbar dense color="primary" app :clipped-left="clipped" dark tabs>

            <v-btn icon @click="goBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Finalizar Ordem</v-toolbar-title>

            <v-spacer/>

        </v-toolbar>

        <main v-if="ordem">

            <v-layout row justify-center>
                <v-dialog v-model="dialog" max-width="290">
                    <v-card>
                        <v-card-title class="headline">Localização</v-card-title>
                        <v-card-text>Cliente sem localização, pretende cadastrar a localização neste momento?</v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn color="green darken-1" flat="flat" @click.native="goBack()">Não</v-btn>
                            <v-btn color="green darken-1" flat="flat" @click.native="openLatLong()">Quero Cadastrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>

            <v-stepper v-model="e1" class="elevation-0">
                <v-stepper-header class="elevation-0">
                    <v-stepper-step :complete="e1 > 1" step="1"/>
                    <v-divider/>
                    <v-stepper-step :complete="e1 > 2" step="2"/>
                    <v-divider/>
                    <v-stepper-step step="3"/>
                </v-stepper-header>
                <v-stepper-items style="border-top: #0d47a1 solid thin">
                    <v-stepper-content step="1">
                        <v-card flat style="height: calc(100vh - 220px)">
                            <h2>MAPA</h2>

                            <br/>
                            <p v-if="mapa">
                                A localização já esta cadastrada.
                                <br/><br/><br/>
                            </p>
                            <p v-else>
                                A localização NÃO esta cadastrada.<br/><br/>Favor cadastrar e informar a localização do cliente
                                <br/><br/><br/>
                            </p>

                            <v-btn color="primary" flat="flat" @click.native="openLatLong()">
                                Cadastrar Posição
                            </v-btn>

                        </v-card>
                        <v-btn color="primary" :disabled="!mapa" @click.native="e1 = 2">AVANÇAR</v-btn>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <v-card class="mb-2" flat style="height: calc(100vh - 220px)">
                            <h2>PRODUTOS</h2>
                            <div v-if="ordem.tipo_contrato === 'INTERNET'">
                                <div v-if="!ordem.retirada_equipamento">

                                </div>
                                <div v-else>
                                    <br/><br/>
                                    <p>Ordem de retirada, favor avançar.</p>
                                </div>
                            </div>
                        </v-card>

                        <v-btn color="primary" @click.native="e1 = 3">AVANÇAR</v-btn>

                        <v-btn flat @click.native="e1 = 1">
                            VOLTAR
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-content step="3">

                        <v-card class="mb-2" flat style="height: calc(100vh - 220px)">
                            <v-form v-model="valid" ref="form" lazy-validation >

                                <v-textarea
                                    name="input-7-2"
                                    label="DIAGNÓSTICO / OBS"
                                    v-model="dados.diagnostico"
                                    rows="8"
                                    class="input-group--focused"
                                />

                                <v-checkbox
                                    label="Tudo checado no cliente"
                                    v-model="dados.checkbox"
                                    :rules="[v => !!v || 'Você precisa confirmar!']"
                                    required
                                />

                            </v-form>
                        </v-card>

                        <v-btn color="primary" @click="submit" :disabled="!valid" >
                            FINALIZAR
                        </v-btn>

                        <v-btn flat @click.native="e1 = 2">VOLTAR</v-btn>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

        </main>
    </div>

</template>

<script>
    import { Ordens } from "../class/ordens";
    import { Sync } from "../class/sync";

    export default {
        name: "finalizar",
        data: () => ({
            valid: false,
            ordem: null,
            e1: 0,
            dialog: false,
            mapa: true,
            clipped: true,
            items: [],
            dados: {
                id_ordem_servico: null,
                action: "CLOSE_ORDEM",
                diagnostico: null,
                checkbox: false
            }
        }),
        beforeMount () {
            Ordens
                .get(parseInt(this.$route.params.id))
                .then((ordem) => {
                    if (ordem) {
                        this.ordem = ordem;
                        this.dados.id_ordem_servico = ordem.id_ordem_servico;
                        if (ordem.id_contratos_servicos) {
                            if (!ordem.latlng || !ordem.latlng.latitude) {
                                this.dialog = true;
                                this.mapa = false;
                            }
                        }
                    } else {
                        this.goBack();
                    }
                })
                .catch((err) => console.error(err));
        },
        methods: {
            openLatLong: function () {
                this.$router.push("/latlong/" + this.$route.params.id);
            },
            goBack: function () {
                this.$router.push("/ver-ordem/" + this.$route.params.id);
            },
            toMaps: function () {
                this.$router.push("/buscar-caixas-maps/" + this.$route.params.id);
            },
            async submit () {
                if (this.$refs.form.validate()) {
                    console.log("OK");
                    let key = await Sync.add(this.dados);
                    await Sync.syncOne(key, this.$socket);
                    await Ordens.del(this.ordem.id_ordem_servico);
                    // await Sync.solicitaNoServer(this.$socket);
                    this.goBack();
                }
            }
        }
    };
</script>

<style scoped>

</style>
